module.exports = __webpack_public_path__ + "static/media/ethelsclub.6334b36d.gif";